import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { EngineTranslateLoader } from './services/engine-translate-loader.service';
import { LabelService } from './services/label.service';
import { EngineTranslationService } from './services/translation.service';

export function provideEngineTranslations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTranslateService({
      loader: { provide: TranslateLoader, useExisting: EngineTranslateLoader },
    }),
    EngineTranslationService,
    LabelService,
    EngineTranslateLoader,
  ]);
}
